import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Users, MapPin, Gift, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { Page, Spinner } from "@/components/shared";

export default function Impact() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/me/impact").then(({ data }) => setD(data)); }, []);
  if (!d) return <div className="px-6 pt-10"><Spinner /></div>;

  const rows = [
    { icon: CheckCircle2, label: "Safety 101", value: d.passport_completed ? "Completed" : "In progress", color: "var(--cs-green)" },
    { icon: Users, label: "Looked out for my crew", value: `${d.checkins} check-ins`, color: "var(--cs-magenta)" },
    { icon: MapPin, label: "Used Safe Points", value: `${d.safe_points_used} times`, color: "var(--cs-blue)" },
    { icon: ShieldCheck, label: "Completed my Safety Passport", value: d.passport_completed ? "Yes" : "Not yet", color: "var(--cs-green)" },
    { icon: Gift, label: "Benefits used", value: `${d.benefits_used}`, color: "var(--cs-amber)" },
  ];

  return (
    <Page className="px-5 pt-6">
      <button data-testid="impact-back" onClick={() => nav(-1)} className="cs-tap flex items-center gap-1 text-sm mb-4" style={{ color: "var(--cs-fg2)" }}>
        <ArrowLeft size={18} /> Back
      </button>
      <h1 className="font-head font-extrabold text-3xl">My Impact</h1>
      <p className="mt-1 text-base" style={{ color: "var(--cs-fg2)" }}>A gentle look back — no scores, no competition.</p>

      <div className="mt-5 space-y-3">
        {rows.map((r) => (
          <div key={r.label} data-testid={`impact-row-${r.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="cs-card p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <r.icon size={22} style={{ color: r.color }} />
              <span className="font-semibold text-sm">{r.label}</span>
            </div>
            <span className="font-head font-bold" style={{ color: r.color }}>{r.value}</span>
          </div>
        ))}
      </div>

      <div className="cs-card mt-6 p-6 text-center magenta-glow" style={{ borderColor: "var(--cs-magenta)" }}>
        <p className="font-head font-extrabold text-2xl">You helped build a safer Carnival.</p>
        <p className="text-sm mt-2" style={{ color: "var(--cs-fg2)" }}>Safer People. Brighter Carnival.</p>
      </div>
    </Page>
  );
}
